'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxForm = require('redux-form');

var _zendesk = require('../../redux/modules/zendesk');

var _EducationalProgramFormValidation = require('../../utils/EducationalProgramFormValidation');

var _EducationalProgramFormValidation2 = _interopRequireDefault(_EducationalProgramFormValidation);

var _EducationProgramPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/popups/EducationProgramPopup');

var _EducationProgramPopup2 = _interopRequireDefault(_EducationProgramPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EducationProgramContainer = (_dec = (0, _reduxForm.reduxForm)({
  form: 'EducationalProgram',
  fields: ['name', 'email', 'url', 'institute', 'subject', 'comments'],
  validate: _EducationalProgramFormValidation2.default
}), _dec2 = (0, _reactRedux.connect)(null, { createTicket: _zendesk.createTicket }), _dec(_class = _dec2(_class = function (_React$Component) {
  (0, _inherits3.default)(EducationProgramContainer, _React$Component);

  function EducationProgramContainer(props) {
    (0, _classCallCheck3.default)(this, EducationProgramContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EducationProgramContainer.__proto__ || (0, _getPrototypeOf2.default)(EducationProgramContainer)).call(this, props));

    _this.state = {
      message: null,
      error: null
    };

    _this.onSubmitClick = _this.onSubmitClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(EducationProgramContainer, [{
    key: 'onSubmitClick',
    value: function onSubmitClick(values) {
      var _this2 = this;

      this.setState({
        message: null,
        error: null
      });

      var email = values.email,
          url = values.url,
          name = values.name,
          subject = values.subject,
          institute = values.institute,
          comments = values.comments;


      var tag = this.props.tag || 'regular';
      var custom_fields = [{
        id: '360000990877',
        value: 'Education_Program'
      }];
      this.props.createTicket({ email: email, subject: subject, comment: comments + '\n Institute' + institute, tag: tag, name: name, url: url, custom_fields: custom_fields }).then(function () {
        _this2.setState({
          message: 'Thank you! We\'ll take a look shortly!'
        });
      }, function (reason) {
        _this2.setState({
          error: reason.message
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$fields = _props.fields,
          nameInputProps = _props$fields.name,
          emailInputProps = _props$fields.email,
          messageProps = _props$fields.comments,
          urlProps = _props$fields.url,
          instituteProps = _props$fields.institute,
          handleSubmit = _props.handleSubmit,
          submitting = _props.submitting,
          title = _props.title,
          description = _props.description,
          tag = _props.tag;

      console.log(this.props);
      return _react2.default.createElement(_EducationProgramPopup2.default, {
        icon: '/quixel_logo.png',
        nameInputProps: nameInputProps,
        emailInputProps: emailInputProps,
        urlInputProps: urlProps,
        instituteNameInputProps: instituteProps
        //subjectInputProps={messageboxInputProps}
        , MessageInputProps: messageProps,
        error: this.state.error,
        message: this.state.message,
        submitting: submitting,
        onSubmit: handleSubmit(this.onSubmitClick),
        title: title,
        description: description,
        tag: tag
      });
    }
  }]);
  return EducationProgramContainer;
}(_react2.default.Component)) || _class) || _class);
exports.default = EducationProgramContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EducationProgramContainer/EducationProgramContainer.jsx
// module id = 2833
// module chunks = 0